import {
  ClimaForceThemeVariableV7,
  DarkThemeVariable,
  DpWorldTourThemeVariable,
  FeyenoordThemeVariable,
  FifaThemeVariable,
  HealthcareVariable,
  HockeyVictoriaSite3ThemeVariable,
  HockyVictoryThemeVariable1,
  HotelPlannerTourThemeVariable,
  LegendsTourThemeVariable,
  LightThemeVariable,
  MelbourneHockeyClubThemeVariable,
} from "./index";

export const ThemeConstantForPrelemThemeBasedOnSite = (siteTheme: any = "LIGHT") => {
  let ThemeConstant;
  switch (siteTheme?.toUpperCase()) {
    case "LIGHT":
      ThemeConstant = LightThemeVariable;
      break;
    case "FIFA":
      ThemeConstant = FifaThemeVariable;
      break;
    case "DARK":
      ThemeConstant = DarkThemeVariable;
      break;
    case "FEYENOORD":
      ThemeConstant = FeyenoordThemeVariable;
      break;
    case "HEALTHCARE":
      ThemeConstant = HealthcareVariable;
      break;
    case "CLIMAFORCEV7":
      ThemeConstant = ClimaForceThemeVariableV7;
      break;
    case "HOCKYVICTORY1":
      ThemeConstant = HockyVictoryThemeVariable1;
      break;
    case "DPWORLDTOUR":
      ThemeConstant = DpWorldTourThemeVariable;
      break;
    case "HOTELPLANNERTOUR":
      ThemeConstant = HotelPlannerTourThemeVariable;
      break;
    case "LEGENDSTOUR":
      ThemeConstant = LegendsTourThemeVariable;
      break;
    case "MELBOURNEHOCKEYCLUB":
      ThemeConstant = MelbourneHockeyClubThemeVariable;
      break;
    case "HOCKEYVICTORIA3":
      ThemeConstant = HockeyVictoriaSite3ThemeVariable;
      break;
    default:
      ThemeConstant = LightThemeVariable;
  }
  return ThemeConstant;
};
